import type { TaxonEntry } from '../../Component/ConfigurableVisualization/Sources/TaxaNavigatorPanel.tsx'

/**
 * Resolve a taxon NAME (as the chat agent supplies via `VizDirective.taxonEntry`) to a concrete
 * lineage `path` using the very taxa index the workspace search panel builds (TaxaNavigatorIndex).
 *
 * The chart's taxonomy depth is driven only by a concrete `selectedPath` lineage (consumed via
 * `setTaxaZoom` + reconciled by the repair epic); the agent, however, only knows a single taxon
 * name. This turns that name into the lineage the search UI would have produced for the same click.
 *
 * Matching is case-insensitive on the label. When the same name appears at several ranks (a name can
 * recur down a lineage, or two hits differ only by depth) we prefer the SHALLOWEST match, so a group
 * like "Coleoptera" zooms to the group node rather than a deeper homonym. Returns `[]` (→ root,
 * today's behavior) when nothing matches — callers must not treat that as an error.
 */
export function resolveTaxonEntryPath(index: TaxonEntry[], name: string): string[] {
  const target = name.trim().toLowerCase()
  if (!target) return []
  let best: TaxonEntry | undefined
  for (const entry of index) {
    if (entry.label.toLowerCase() !== target) continue
    if (!best || entry.level < best.level) best = entry
  }
  return best ? best.path : []
}
